import { AppState as State } from '@ducks/index';

export const getRefreshId = (state: State) => state.userLicense.refresh;

export const checkIsLoading = (state: State) => state.userLicense.isLoading;

export const getLicenseInfo = (state: State) => state.userLicense.licenseInfo;
